export default __webpack_public_path__ + "static/media/safari.a73dac21.jpg";